import { render } from "./Userdetails.vue?vue&type=template&id=1d69803a&scoped=true"
import script from "./Userdetails.vue?vue&type=script&lang=js"
export * from "./Userdetails.vue?vue&type=script&lang=js"

import "./Userdetails.vue?vue&type=style&index=0&id=1d69803a&scoped=true&lang=css"

import exportComponent from "/Users/alexisbailly/Documents/Programming/Website/vueform/Wealth & Retirement/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d69803a"]])

export default __exports__